// announcement bar js ===========

var swiper = new Swiper(".announcement_slider", {
  spaceBetween: 30,
  centeredSlides: true,
  loop: true,
  // autoplay: {
  //   delay: 4000,
  // },
});

// hero banner slider js =========

var swiper = new Swiper(".hero_banner_slider", {
  slidesPerView: 1,
  loop: true,
  autoplay: true,
  pagination: {
    el: ".hero_slider_btn .swiper-pagination",
    clickable: true,
  },
});

// category collection js ========

var swiper = new Swiper(".category_coll_slider", {
  slidesPerView: 1.5,
  spaceBetween: 20,
  centeredSlides: true,
  loop: true,
  autoplay: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 3.5,
      spaceBetween: 20,
    },
    992: {
      slidesPerView: 3.8,
      spaceBetween: 20,
    },
    1441: {
      slidesPerView: 5.4,
      spaceBetween: 30,
    },
  },
});

// selling points js =========

var swiper = new Swiper(".selling_points_slider", {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  autoplay: true,
  breakpoints: {
    370: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    425: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
    900: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1025: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
});

// tabify collection slider js ==============

var swiper = new Swiper(".tabify_collectio_slider", {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  navigation: {
    nextEl: ".tab_coll_slider_btn .swiper-button-next",
    prevEl: ".tab_coll_slider_btn .swiper-button-prev",
  },
  breakpoints: {
    370: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    992: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    1441: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
  },
});

// tabify js =====
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab_box");
  const tabContents = document.querySelectorAll(".tab_content");

  // Swiper slider settings
  function initializeSwiper(slider) {
    if (!slider.classList.contains("swiper-initialized")) {
      new Swiper(slider, {
        slidesPerView: 2,
        spaceBetween: 10,
        loop: true,
        autoplay: {
          delay: 3000,
        },
      });
    }
  }

  // Initialize Swiper for the first active tab content
  const firstTabContent = document.querySelector(
    ".tab_content.active .tabify_collectio_slider"
  );
  if (firstTabContent) {
    initializeSwiper(firstTabContent);
  }

  // Mobile tabs click functionality
  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      // Remove active class from all tabs and tab content
      tabs.forEach((t) => t.classList.remove("active"));
      tabContents.forEach((content) => content.classList.remove("active"));

      // Add active class to clicked tab and corresponding content
      this.classList.add("active");
      const tabIndex = this.dataset.tab;
      const tabContent = document.querySelector(`#tab-content-${tabIndex}`);
      tabContent.classList.add("active");

      // Initialize Swiper for the newly active tab content
      const slider = tabContent.querySelector(".tabify_collectio_slider");
      if (slider) {
        initializeSwiper(slider);
      }
    });
  });
});

// load more product js ========

// jQuery(window).on("load", function () {
//   if (jQuery(".load_more_btn").length === 0) {
//     jQuery(".product-grid--root").append(
//       '<div class="load_more_btn"><a href="#" class="btn loadMoreBtn" id="loadMore"><span class="loadMoreBtn-label">Load More</span></a></div>'
//     );
//   }

//   if (jQuery(".product-grid--root > .product--root").length <= 24) {
//     jQuery(".loadMoreBtn").hide(); 
//   }

//   jQuery(".product-grid--root > .product--root").hide();
//   jQuery(".product-grid--root > .product--root").slice(0, 24).show(); 

//   jQuery(".loadMoreBtn").on("click", function (e) {
//     e.preventDefault();
    
//     let hiddenProducts = jQuery(".product-grid--root > .product--root:hidden");  
//     hiddenProducts.slice(0, 10).fadeIn(function () {
      
//       // Section height auto set
//       jQuery(".product-grid--root").css("height", "auto");

//       // Resize event with delay
//       setTimeout(() => {
//         jQuery(window).trigger("resize"); 
//       }, 100);
//     });

//     if (hiddenProducts.length <= 10) { 
//       jQuery(".loadMoreBtn").hide(); 
//     }
//   });
// });





